module.exports = __webpack_public_path__ + "static/media/certificate-icon.2f75c461.png";